const translation = {
  custom: 'Tùy chỉnh',
  upgradeTip: {
    prefix: 'Nâng cấp gói của bạn để',
    suffix: 'tùy chỉnh thương hiệu.',
    des: 'Nâng cấp kế hoạch của bạn để tùy chỉnh thương hiệu của bạn',
    title: 'Nâng cấp gói của bạn',
  },
  webapp: {
    title: 'Tùy chỉnh thương hiệu web app',
    removeBrand: 'Xóa "Được hỗ trợ bởi Dify"',
    changeLogo: 'Thay đổi logo "Được hỗ trợ bởi"',
    changeLogoTip: 'Định dạng SVG hoặc PNG với kích thước tối thiểu 40x40px',
  },
  app: {
    title: 'Tùy chỉnh thương hiệu tiêu đề ứng dụng',
    changeLogoTip: 'Định dạng SVG hoặc PNG với kích thước tối thiểu 80x80px',
  },
  upload: 'Tải lên',
  uploading: 'Đang tải lên',
  uploadedFail: 'Tải ảnh lên thất bại, vui lòng thử lại.',
  change: 'Thay đổi',
  apply: 'Áp dụng',
  restore: 'Khôi phục mặc định',
  customize: {
    contactUs: 'liên hệ với chúng tôi',
    prefix: 'Để tùy chỉnh logo thương hiệu trong ứng dụng, vui lòng',
    suffix: 'để nâng cấp lên phiên bản Doanh nghiệp.',
  },
}

export default translation
